export const filterInvalidMentionList = (
  mentionList: Array<{ startIndex: number; length: number; userId: string }>,
  value: string
) => {
  if (!value.includes('@')) {
    return mentionList
  }
  return mentionList.filter(mention => {
    if (
      value[mention.startIndex] === '@' &&
      [' ', undefined].includes(value[mention.startIndex + mention.length])
    ) {
      return true
    } else {
      console.log('debug filterInvalidMentionList', mention, JSON.stringify(value))
      return false
    }
  })
}
